"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _store = require('shared/store');


var _uuid = require('shared/services/uuid');
var _smsParts = require('shared/services/composer/smsParts');
var _chat = require('./chat'); var _chat2 = _interopRequireDefault(_chat);















const unsentPartsByKey = new Map()

const rowOf = (ConversationKey, MessageKey) =>
  _optionalChain([_store.getState.call(void 0, ), 'optionalAccess', _ => _.dataV2, 'access', _2 => _2.messages, 'access', _3 => _3[ConversationKey], 'optionalAccess', _4 => _4.find, 'call', _5 => _5(m => m.MessageKey === MessageKey)])

// The row a send has just added is the last in its chat.
const lastMessageKey = (ConversationKey) =>
  _optionalChain([_store.getState.call(void 0, ), 'optionalAccess', _6 => _6.dataV2, 'access', _7 => _7.messages, 'access', _8 => _8[ConversationKey], 'optionalAccess', _9 => _9.at, 'call', _10 => _10(-1), 'optionalAccess', _11 => _11.MessageKey])

// A part never sent because one before it failed: it shows as not sent,
// with Retry, in its place.
const markNotSent = (ConversationKey, TextContent, Mentions) => {
  const MessageKey = _uuid.uuidv4.call(void 0, ) 
  const meta = { ConversationKey, MessageKey, isRetrying: false, ...(Mentions.length ? { Mentions } : {}) }
  _store.dispatch.call(void 0, _chat.actionCreators.sendMessageToConversationActions.REQUEST({ ConversationKey, MessageKey, TextContent }, meta))
  _store.dispatch.call(void 0, _chat.actionCreators.sendMessageToConversationActions.FAILURE(new Error('Not sent'), meta))
  return MessageKey
}

/* Sends a plain-SMS text as its numbered parts (splitSmsMessage), each an
 * ordinary message, one after another; a text that fits goes as itself. The
 * reply and mentions ride on part 1. When a part fails it shows Retry, and
 * the parts after it are not sent, so none arrives ahead of it: each shows as
 * not sent, with its own Retry, and waits behind it. Rejects when a part
 * failed. */
const sendConversationSmsParts = async (
  ConversationKey,
  text,
  replyToMessageKey,
  replyPreview,
  mentions = [],
) => {
  const parts = _smsParts.splitSmsMessage.call(void 0, text, mentions)
  for (const [i, part] of parts.entries()) {
    const sending = _chat2.default.sendConversationMessage(
      ConversationKey, part.text, undefined, undefined,
      i === 0 ? replyToMessageKey : undefined,
      i === 0 ? replyPreview : undefined,
      part.mentions,
    )
    const MessageKey = lastMessageKey(ConversationKey)
    try {
      await sending
    } catch (err) {
      if (MessageKey && i < parts.length - 1) {
        const unsent = { parts: [], sending: false }
        unsent.parts.push({ MessageKey, text: part.text, mentions: part.mentions })
        for (const rest of parts.slice(i + 1)) {
          unsent.parts.push({
            MessageKey: markNotSent(ConversationKey, rest.text, rest.mentions),
            text: rest.text,
            mentions: rest.mentions,
          })
        }
        unsent.parts.forEach(p => unsentPartsByKey.set(p.MessageKey, unsent))
      }
      throw err
    }
  }
}

/* Retries a text that failed to send. A numbered part waits while an earlier
 * part of its send is still not sent: it is left as it is and this resolves
 * 'waiting'. Otherwise the part is sent, then each part after it in order,
 * stopping again at one that fails (it rejects then, and the rest wait behind
 * that one). Any other text is simply sent again. */
const retryConversationTextMessage = async (
  ConversationKey,
  MessageKey,
  text,
  mentions,
) => {
  const unsent = unsentPartsByKey.get(MessageKey)
  if (!unsent) {
    await _chat2.default.sendConversationMessage(ConversationKey, text, undefined, MessageKey, undefined, undefined, mentions)
    return 'sent'
  }

  // A part the user removed no longer holds up the ones after it.
  const isGone = (part) => {
    const row = rowOf(ConversationKey, part.MessageKey)
    return !row || row.Deleted
  }
  while (unsent.parts[0] && isGone(unsent.parts[0])) {
    unsentPartsByKey.delete(unsent.parts.shift().MessageKey)
  }
  if (unsent.sending || _optionalChain([unsent, 'access', _12 => _12.parts, 'access', _13 => _13[0], 'optionalAccess', _14 => _14.MessageKey]) !== MessageKey) return 'waiting'

  unsent.sending = true
  try {
    for (let part = unsent.parts[0]; part; part = unsent.parts[0]) {
      const retried = part.MessageKey === MessageKey
      await _chat2.default.sendConversationMessage(
        ConversationKey,
        retried ? text : part.text,
        undefined,
        part.MessageKey,
        undefined,
        undefined,
        retried ? mentions : part.mentions,
      )
      unsent.parts.shift()
      unsentPartsByKey.delete(part.MessageKey)
    }
  } finally {
    unsent.sending = false
  }
  return 'sent'
}

exports. default = { sendConversationSmsParts, retryConversationTextMessage }
